export default "__VITE_ASSET__DeETdzQ3__"